(() => {
  const initialise = (root = document) => {
    root.querySelectorAll('[data-lp-devices]').forEach(selector => {
      if (selector.dataset.ready) return;
      selector.dataset.ready = 'true';
      const main = selector.closest('main');
      const buttons = [...selector.querySelectorAll('[data-lp-device]')];
      const panels = {
        fly6: [...main.querySelectorAll('[id$="__inclusions"],[id$="__specifications"]')],
        fly12: [...main.querySelectorAll('[id$="__fly12_inclusions"],[id$="__fly12_specs"]')]
      };
      const select = button => {
        const device = button.dataset.lpDevice;
        main.dataset.lpDevice = device;
        selector.querySelector('.lp-device-selector__name').textContent = button.textContent;
        buttons.forEach(item => {
          const active = item === button;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          item.setAttribute('aria-controls', panels[item.dataset.lpDevice].map(panel => panel.id).join(' '));
          panels[item.dataset.lpDevice].forEach(panel => {
            panel.hidden = !active;
            panel.setAttribute('role', 'tabpanel');
            panel.setAttribute('aria-labelledby', item.id);
          });
        });
      };
      buttons.forEach((button,index) => {
        button.addEventListener('click', () => select(button));
        button.addEventListener('keydown', event => {
          if (!['ArrowLeft','ArrowRight','Home','End'].includes(event.key)) return;
          event.preventDefault();
          const next = event.key === 'Home' ? buttons[0] : event.key === 'End' ? buttons.at(-1) : buttons[(index + 1) % buttons.length];
          select(next);
          next.focus();
        });
      });
      select(buttons[0]);
    });
    root.querySelectorAll('[data-lp-gallery]').forEach(gallery => {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = 'true';
      const slides = [...gallery.querySelectorAll('[data-lp-slide]')];
      const controls = [...gallery.querySelectorAll('[data-lp-thumbnail]')];
      // Use the same scroll engine as the current PDP media gallery.
      customElements.whenDefined('scroll-carousel').then(() => {
        if (!gallery.isConnected || !slides.length) return;
        const stage = gallery.querySelector('.lp-product__slides');
        const track = document.createElement('scroll-carousel');
        track.className = `${stage.className} is-carousel`;
        track.tabIndex = 0;
        track.setAttribute('role', 'region');
        track.setAttribute('aria-label', 'Product images. Use the arrow keys to browse.');
        const select = index => track.select(index, {animate: !matchMedia('(prefers-reduced-motion: reduce)').matches});
        track.addEventListener('carousel:change', event => {
          controls.forEach((control, position) => control.setAttribute('aria-pressed', String(position === event.detail.index)));
        });
        track.addEventListener('keydown', event => {
          if (event.target !== track || !['ArrowLeft', 'ArrowRight'].includes(event.key)) return;
          event.preventDefault();
          select(Math.max(0, Math.min(slides.length - 1, track.selectedIndex + (event.key === 'ArrowRight' ? 1 : -1))));
        });
        slides.forEach(slide => { slide.hidden = false; track.append(slide); });
        stage.replaceWith(track);
        controls.forEach((button, index) => button.addEventListener('click', () => select(index)));
      });
    });
    root.querySelectorAll('[data-lp-carousel]').forEach(carousel => {
      if (carousel.dataset.ready) return;
      carousel.dataset.ready = 'true';
      const track = carousel.querySelector('[data-lp-track]');
      const previous = carousel.querySelector('[data-lp-prev]');
      const next = carousel.querySelector('[data-lp-next]');
      if (!track || !previous || !next) return;
      const refresh = () => {
        previous.disabled = track.scrollLeft < 2;
        next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      };
      const move = direction => track.scrollBy({left: direction * track.clientWidth * .85, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
      previous.addEventListener('click', () => move(-1));
      next.addEventListener('click', () => move(1));
      track.addEventListener('scroll', refresh, {passive: true});
      new ResizeObserver(refresh).observe(track);
      refresh();
    });
    root.querySelectorAll('[data-lp-countdown]').forEach(timer => {
      if (timer.dataset.ready) return;
      timer.dataset.ready = 'true';
      const value = timer.dataset.lpCountdown;
      const deadline = /(?:Z|[+-]\d{2}:\d{2})$/.test(value) ? Date.parse(value) : NaN;
      if (!Number.isFinite(deadline)) return;
      let interval;
      const update = () => {
        const seconds = Math.floor((deadline - Date.now()) / 1000);
        if (seconds <= 0 || !timer.isConnected) { timer.hidden = true; clearInterval(interval); return; }
        timer.hidden = false;
        const values = [Math.floor(seconds / 86400), Math.floor(seconds / 3600) % 24, Math.floor(seconds / 60) % 60, seconds % 60];
        timer.querySelectorAll('[data-countdown-value]').forEach((element, index) => { element.textContent = String(values[index]).padStart(2, '0'); });
      };
      update();
      if (!timer.hidden) interval = setInterval(update, 1000);
    });
  };
  initialise();
  document.addEventListener('shopify:section:load', event => initialise(event.target));
})();
